/**
 * Interface to keep track of localStorage keys used and stored in the dashboard application
 */
export enum LocalStorageKeys {
  HomeUrlInfoClosed = 'home-url-info-closed',
  InstanceInfoClosed = 'instance-info-closed',
}
